(function() {
  'use strict';

  angular.module('ringbaPortal').component('trTargetGroup', {
    bindings: {
      onSave: '&',
      onDismiss: '&',
      targetGroup: '<'
    },
    controller: TargetGroupController,
    controllerAs: 'vm',
    templateUrl: '/scripts/components/targetgroups/target-group.view.html'
  });

  function TargetGroupController(
    $state,
    $anchorScroll,
    infoService,
    concurrencyMatrixService,
    utils
  ) {

    const vm = this;

    vm.$onInit = onInit;
    vm.onSaveGroup = onSaveGroup;

    function onInit() {
      if (vm.targetGroup) {
        _loadTargetGroup(angular.copy(vm.targetGroup));
      } else {
        vm.currentTargetGroup = {};
      }

      _loadConversionSettings();
    }

    function onSaveGroup(event) {
      $anchorScroll();
      if (event.newTargetGroup) {
        _changeURLByAddingId(event.targetGroup.id);
        vm.targetGroupId = event.targetGroup.id;
      }
      _loadTargetGroup(event.targetGroup);
      vm.onSave(event);
    }

    function _changeURLByAddingId(targetGroupId) {
      $state.go('dashboard.targetgroup.new', {
        targetGroupId: targetGroupId
      });
    }

    function _loadConversionSettings() {
      infoService.getConversionSettings()
        .then(function (response) {
          vm.conversionSettings = response.data;
        })
        .catch(utils.errorHandler);
    }

    function _loadTargetGroup(targetGroup) {
      vm.currentTargetGroup = targetGroup;
      if (vm.currentTargetGroup.schedule && vm.currentTargetGroup.schedule.callCapMatrix) {
        vm.currentTargetGroup.schedule.callCapMatrix = concurrencyMatrixService.getProcessMatrix(vm.currentTargetGroup.schedule.callCapMatrix);
      }
    }
  }
})();
